import { customerRequestOrderFillOrKill } from "@goodfill/backend-api-client";
import { OrderTicketId } from "@goodfill/domain-properties";
import { Button } from "@goodfill/ui-components";
import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import { useRecoilValue } from "recoil";
import { backendFetcher } from "../backendApi/backendApi";
import { userAuthState } from "../../state";
import { toastErrorHandler } from "../../unexpectedErrorHandler";
import { useLogout } from "../useLogout";

export const OrderKillOrFillButton = ({ orderId, onSuccess }: { orderId: OrderTicketId; onSuccess?: () => void }) => {
  const [isLoading, setIsLoading] = useState(false);
  const userData = useRecoilValue(userAuthState);

  const logout = useLogout();

  const onFillOrKillClick = useCallback(async () => {
    if (userData === null) {
      return;
    }

    setIsLoading(true);
    (await customerRequestOrderFillOrKill(backendFetcher, { orderId }, userData.idToken)).match({
      success: () => {
        toast.success("Fill or Kill request send");
        onSuccess?.();
      },
      businessMatcher: {},
      unexpected: toastErrorHandler,
      unauthorized: logout,
    });

    setIsLoading(false);
  }, [orderId, onSuccess, userData, logout]);

  return (
    <Button
      fill
      size="small"
      uppercase={true}
      red={true}
      loading={isLoading}
      onClick={onFillOrKillClick}
      data-testid={`fillOrKill-${orderId}`}
    >
      fill or kill
    </Button>
  );
};
